import { render, staticRenderFns } from "./patientAllSelect.vue?vue&type=template&id=3add7f8e&scoped=true"
import script from "./patientAllSelect.vue?vue&type=script&lang=js"
export * from "./patientAllSelect.vue?vue&type=script&lang=js"
import style0 from "./patientAllSelect.vue?vue&type=style&index=0&id=3add7f8e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3add7f8e",
  null
  
)

export default component.exports